import React from "react";
import { Helmet } from "react-helmet";
import { useLocale } from "../../hooks/use-locale";

interface HeaderConfigProps {
  nonce: string;
}

const HeaderConfig = ({ nonce }: HeaderConfigProps) => {
  const { locale } = useLocale();
  const googleAnalyticsSource = "https://www.google-analytics.com";
  const googleTagManagerSource = "https://www.googletagmanager.com";
  const siteimproveSource = "https://siteimproveanalytics.com/js/siteanalyze_6067402.js";
  const siteImproveDataDelivery = "https://*.siteimproveanalytics.io";
  const sanitySource = "https://cdn.sanity.io";
  const thinkificSource = "https://*.cdn.thinkific.com";
  const brregSource = "https://data.brreg.no";
  const fontAwesomeSource = "https://use.fontawesome.com/releases/v5.15.1/css/svg-with-js.css";
  const hotjarSources =
    "http://*.hotjar.com https://*.hotjar.com http://*.hotjar.io https://*.hotjar.io wss://*.hotjar.com";
  const hotjarScriptHash = "'sha256-egbF0MoXUlqmi36mNgTGikLQbeU7BRBKOaENsJNKMGo='";
  const oneTrustSources = "https://cdn.cookielaw.org/ https://geolocation.onetrust.com/";
  const cdnUriSource = "https://component-library-cdn-dev.innovasjonnorge.no/fonts/";
  const signOutUrlSources =
    "https://idporten.difi.no https://idporten-ver1.difi.no https://idporten-ver2.difi.no https://*.innovasjonnorge.no";
  const gStaticSources = "fonts.gstatic.com";
  const googleFontsSources = "https://fonts.googleapis.com";

  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      <meta
        httpEquiv="Content-Security-Policy"
        content={`
        default-src 'self';
        script-src 'self' 'nonce-${nonce}' 'unsafe-eval' ${googleAnalyticsSource} ${googleTagManagerSource} ${siteimproveSource} ${hotjarSources} ${hotjarScriptHash} ${oneTrustSources} https://uxsignals-frontend.uxsignals.app.iterate.no;
        style-src 'self' 'unsafe-inline' ${fontAwesomeSource} ${googleFontsSources};
        img-src 'self' data: ${googleAnalyticsSource} ${googleTagManagerSource} ${hotjarSources} ${sanitySource} ${thinkificSource} ${signOutUrlSources} ${oneTrustSources} ${siteImproveDataDelivery} https://uxsignals-frontend.uxsignals.app.iterate.no;
        connect-src 'self' wss: ${googleAnalyticsSource} ${hotjarSources} ${oneTrustSources} ${brregSource} https://stats.g.doubleclick.net https://api.uxsignals.com;
        font-src 'self' ${hotjarSources} ${cdnUriSource} ${gStaticSources};
        frame-src 'self' ${hotjarSources};
        `}
      />

      {/* <!-- Google Tag Manager --> */}
      <script nonce={nonce}>
        {`(function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({
            'gtm.start':
            new Date().getTime(), event: 'gtm.js'
          }); var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; var n = d.querySelector('[nonce]');
          n && j.setAttribute('nonce', n.nonce || n.getAttribute('nonce')); f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-KQX6LZG');`}
      </script>
      {/* <!-- End Google Tag Manager --> */}
    </Helmet>
  );
};

export default HeaderConfig;
